package pl.mothdigital.neuronowi.components.sections.offer

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.icons.fa.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import pl.mothdigital.neuronowi.components.text.*
import pl.mothdigital.neuronowi.components.widgets.*
import pl.mothdigital.neuronowi.common.utils.fixPolishOrphans
import pl.mothdigital.neuronowi.theme.*

@Composable
fun OfferSection() {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .toAttrs()
    ) {
        Column(modifier = Modifier.fillMaxWidth()) {
            AppH2 { Text("Nasze specjalizacje") }

            VerticalSpacer(height = 1.cssRem)

            Row(
                modifier = Modifier.flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.spacedBy(1.cssRem),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                SpecializationCard("Logopedia", "Wsparcie rozwoju mowy i komunikacji", { FaBookOpen(it) })
                SpecializationCard("Neurologopedia", "Terapia neurologicznych zaburzeń mowy", { FaBrain(it) })
                SpecializationCard("Psychologia", "Pomoc psychologiczna dzieciom i dorosłym", { FaUser(it) })
                SpecializationCard("Pedagogika", "Wspieranie rozwoju i edukacji", { FaChalkboardUser(it) })
                SpecializationCard("Fizjoterapia", "Rehabilitacja ruchowa i neurologiczna", { FaHandHoldingHeart(it) })
                SpecializationCard("Integracja sensoryczna", "Terapia przetwarzania bodźców", { FaPuzzlePiece(it) })
            }
        }
    }
}

@Composable
fun SpecializationCard(
    title: String,
    description: String,
    icon: @Composable (Modifier) -> Unit
) {
    Column(
        modifier = Modifier
            .widthIn(min = 260.px, max = 100.percent)
            .heightIn(min = 250.px, max = 300.px)
            .flex(1)
            .padding(1.cssRem)
            .margin(1.cssRem)
            .borderRadius(1.cssRem)
            .backgroundColor(SiteTheme.white._900)
            .boxShadow(blurRadius = 8.px, color = rgba(0, 0, 0, 0.1)),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center,
    ) {
        icon(Modifier.fontSize(2.cssRem).margin(bottom = 0.5.cssRem).color(SiteTheme.green._900))
        AppH3(modifier = Modifier.textAlign(TextAlign.Center)) { Text(title.fixPolishOrphans()) }
        AppP(modifier = Modifier.textAlign(TextAlign.Center)) { Text(description.fixPolishOrphans()) }
    }
}
